
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/withdrawals",
      function () {
        return require("private-next-pages/withdrawals/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/withdrawals"])
      });
    }
  